'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _isInteger = require('babel-runtime/core-js/number/is-integer'),
    _isInteger2 = _interopRequireDefault(_isInteger),
    _formatting = require('../formatting');

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

exports.default = function (a, b) {
  var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : 'date';

  if ((0, _isInteger2.default)(b)) {
    var d = (0, _formatting.formatOdooDate2Sys)(a);
    return 'date' === c ? d.setDate(d.getDate() + parseInt(b)) : 'month' === c ? d.setMonth(d.getMonth() + parseInt(b)) : 'year' === c && d.setFullYear(d.getFullYear() + parseInt(b)), (0, _formatting.formatSys2OdooDate)(d);
  }

  return a;
};